import { render, staticRenderFns } from "./AddPatientAccount.vue?vue&type=template&id=ce3d64e8&scoped=true"
import script from "./AddPatientAccount.vue?vue&type=script&lang=ts"
export * from "./AddPatientAccount.vue?vue&type=script&lang=ts"
import style0 from "./AddPatientAccount.vue?vue&type=style&index=0&id=ce3d64e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3d64e8",
  null
  
)

export default component.exports